import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=4adffda4&"
import script from "@/scripts/Events/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Events/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports